import React, { useState } from "react";

function Accordion({ title, content }) {
  const minusIcon = "-";
  const plusIcon = "+";
  const [expanded, setExpanded] = useState(false);
  const toggleExpanded = () => setExpanded((current) => !current);

  return (
    <div
      className="my-2 sm:my-4 md:my-6 shadow-sm cursor-pointer bg-white"
      onClick={toggleExpanded}
    >
      <div className="px-6 text-left items-center text-md font-semibold min-h-12 select-none flex justify-between flex-row border border-transparent">
        <h5 className="flex-1" dangerouslySetInnerHTML={{ __html: title }}></h5>
        <div className="flex-none pl-2 text-xl">{expanded ? minusIcon : plusIcon}</div>
      </div>
      <div
        className={`px-6 pt-0 overflow-hidden transition-[max-height] duration-300 ease-in ${
          expanded ? "max-h-90" : "max-h-0"
        }`}
      >
        <div className="pb-4 text-left" dangerouslySetInnerHTML={{ __html: content }}></div>
      </div>
    </div>
  );
}

export default Accordion;
